import type { LyricsSyncMode } from '@/store/useUISettingsStore'
import type { TranscriptLine } from '@/types/audiobook-transcript'

/** 音節単位の時刻を持つか。無ければカラオケ塗りができないため強制アライメントの対象になる */
export const hasWordLevelTiming = (lines: TranscriptLine[]): boolean => lines.some((l) => l.words.length > 0)

/** 行の時刻を持たない（全行の start/end が 0）。この歌詞はどう設定しても再生に追従できない */
export const isUntimedLyrics = (lines: TranscriptLine[]): boolean =>
  lines.length > 0 && lines.every((l) => l.start === 0 && l.end === 0)

/** 設定された同期粒度を、歌詞データが実際に扱える粒度まで落とし込む */
export const resolveLyricsSyncMode = (lines: TranscriptLine[], preferred: LyricsSyncMode): LyricsSyncMode => {
  if (preferred === 'none' || isUntimedLyrics(lines)) return 'none'
  if (preferred === 'word' && !hasWordLevelTiming(lines)) return 'line'
  return preferred
}
